<template>
  <section class="highlight dark" id="highlight">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 offset-lg-8">
          <div class="card" :data-tag="t('Most Popular')">
            <div class="price">
              <h4>{{ t('Growth Plan') }}</h4>
              <h2 class="d-inline-block text-primary me-2">MYR 118</h2>
              <span>{{ t('/month') }}</span>
              <a href="#pricing">
                <font-awesome-icon :icon="['far', 'arrow-right']" />
              </a>
            </div>
            <div class="small">{{ t('Great for growing businesses who want a professional image and improve their branding.') }}</div>
          </div>
        </div>
      </div>
      <div class="row gy-4">
        <div class="col-md-4">
          <font-awesome-icon icon="server" />
          <h4 class="text-white mb-4">{{ t('Free Hosting & Domain') }}</h4>
          <p>{{ t("We provide scalable web hosting and top-level domain name for your website as long as you're part of our big family.") }}</p>
        </div>
        <div class="col-md-4">
          <font-awesome-icon icon="award" />
          <h4 class="text-white mb-4">{{ t('Free SSL Certificate') }}</h4>
          <p>{{ t('We provide SSL certificate and make sure that your website is secured, your security and privacy as a right should never be charged.') }}</p>
        </div>
        <div class="col-md-4">
          <font-awesome-icon icon="envelope" />
          <h4 class="text-white mb-4">{{ t('Free Business Emails') }}</h4>
          <p>{{ t('We provide multiple business emails that use your custom domain to give all your work emails a professional makeover.') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.highlight {
  padding-bottom: 2.5rem;

  .row:nth-child(1) {
    .card {
      border-radius: 0.25rem;
      box-shadow: 0 0.25rem 0.25rem 0 rgb(25 25 25 / 5%);
      margin-bottom: 3rem;
      margin-top: -15rem;
      padding: 4rem 1.25rem 1.25rem;
      min-height: 225px;

      &::before {
        background: #fd0d6e;
        border-radius: 0.25rem;
        box-shadow: 0 0.25rem 0.5rem rgb(253 13 110 / 50%);
        color: #fff;
        content: attr(data-tag);
        font-size: 0.85rem;
        font-weight: 500;
        left: -1rem;
        padding: 0.25rem 0.75rem;
        position: absolute;
        top: 1rem;
      }

      &::after {
        background: #fff;
        border-radius: 0.25rem;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        content: '';
        height: 0.75rem;
        left: 0.75rem;
        opacity: 0.25;
        position: absolute;
        top: 100%;
        width: calc(100% - 1.5rem);
      }

      .price {
        position: relative;

        a {
          color: #ddd;
          font-size: 2rem;
          position: absolute;
          right: 0.5rem;
          top: calc(50% - 24px);
        }
      }

      @media (max-width: 991.98px) {
        min-height: unset;
      }
    }
  }

  .row:nth-child(2) {
    div[class^='col-'] {
      svg {
        align-items: center;
        border-radius: 1.65rem;
        border: solid 1px rgb(255 255 255 / 25%);
        color: #fff;
        display: flex;
        height: 60px;
        justify-content: center;
        margin-bottom: 1.5rem;
        padding: 1rem;
        position: relative;
        width: 60px;
        z-index: 10;
      }
    }
  }
}
</style>

<script>
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          '/month': '/ month',
          'Free Business Emails': 'Free Business Emails',
          'Free Hosting & Domain': 'Free Hosting & Domain',
          'Free SSL Certificate': 'Free SSL Certificate',
          'Great for growing businesses who want a professional image and improve their branding.': 'Great for growing businesses who want a professional image and improve their branding.',
          'Growth Plan': 'Growth Plan',
          'Most Popular': 'Most Popular',
          'We provide multiple business emails that use your custom domain to give all your work emails a professional makeover.': 'We provide multiple business emails that use your custom domain to give all your work emails a professional makeover.',
          'We provide SSL certificate and make sure that your website is secured, your security and privacy as a right should never be charged.': 'We provide SSL certificate and make sure that your website is secured, your security and privacy as a right should never be charged.',
          "We provide scalable web hosting and top-level domain name for your website as long as you're part of our big family.": "We provide scalable web hosting and top-level domain name for your website as long as you're part of our big family."
        },
        'zh-MY': {
          '/month': '/ 每月',
          'Free Business Emails': '免费商务电子邮箱',
          'Free Hosting & Domain': '免费网络托管和顶级域名',
          'Free SSL Certificate': '免费SSL认证',
          'Great for growing businesses who want a professional image and improve their branding.': '我们所提供的成长配套适合想要拥有专业形象，并且希望能够改善其品牌的成长中企业。',
          'Growth Plan': '成长配套',
          'Most Popular': '最受欢迎',
          'We provide multiple business emails that use your custom domain to give all your work emails a professional makeover.': '我们将提供您多个可客制化的商务电子邮箱。这些商业邮箱将使用您的顶级域名，以确保您的工作电邮无时无刻都保持专业。',
          'We provide SSL certificate and make sure that your website is secured, your security and privacy as a right should never be charged.': '我们将提供您SSL认证，并且时刻确保您的网站受到保护。您的安全及隐私本是您的基本的权力，并不应该沦为一种商业消费。',
          "We provide scalable web hosting and top-level domain name for your website as long as you're part of our big family.": '我们将提供您可扩展式虚拟伺服器以及顶级域名，只要您持续订阅我们并成为我们大家庭的一员，即可享受永久的网络托管与域名服务。'
        },
        'ms-MY': {
          '/month': '/ bulan',
          'Free Business Emails': 'E-mel Business Percuma',
          'Free Hosting & Domain': 'Hosting & Domain Percuma',
          'Free SSL Certificate': 'Sijil SSL Percuma',
          'Great for growing businesses who want a professional image and improve their branding.': 'Sesuai untuk perusahanan yang ingin meningkatkan imej profesional dan jenama mereka.',
          'Growth Plan': 'Pelan "Growth"',
          'Most Popular': 'Paling Popular',
          'We provide multiple business emails that use your custom domain to give all your work emails a professional makeover.': 'Kami membekalkan e-mel business yang menggunakan domain anda untuk meningkatkan imej professional anda.',
          'We provide SSL certificate and make sure that your website is secured, your security and privacy as a right should never be charged.': 'Kami membekalkan sijil SSL dan memastikan keselamatan website anda terjamin. Keselamatan dan privasi adalah hak anda.',
          "We provide scalable web hosting and top-level domain name for your website as long as you're part of our big family.": 'Kami membekalkan hosting web dan domain peringkat atasan selagi anda sebahagian daripada keluarga besar kami.'
        }
      }
    });

    return { t };
  }
};
</script>
